<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-graph icons font-2xl mt-4"></i>SkyExpress Shipment Tracking </strong>
            <div class="card-header-actions">                      
            </div>
          </div>  
          <div class="box">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >  
                  <b-col sm="12" >
                  <b-form-group label="Shipment Id" :label-cols="3"> 
                   <b-form-input class="input" type="text" name="shipmentid" v-model="customer.shipmentid" v-validate="'required|'" :class="{'input': true, 'is-danger': errors.has('form-1.shipmentid') }" placeholder="Enter Shipment Id ">
                   </b-form-input>
                    <span v-show="errors.has('form-1.shipmentid')" class="help text-danger">{{ errors.first('form-1.shipmentid') }}</span>
                   </b-form-group> 
                   </b-col>         
                </b-col> 
                <b-col md="6" >
                  <b-button type="submit" size="md" class="mr-4" variant="primary"> Search</b-button>
                  <b-button type="button" size="md" variant="danger" @click="clear"> Clear</b-button>               
                </b-col>
              </b-row>  
            </form>
          </div> 
           <b-modal size="xl" v-model="showskyexpress"  title="SkyExpress Tracking" ok-only  >
       
         <div class="row md-12"> 
            <b-col md="12">
       <!-- src="https://mydhl.express.dhl/in/en/tracking.html#/results?id=trackingnumber"  -->
       
        <iframe  :src="finaltrackinglink"   width="100%" height="420px" title="SkyExpress">
       </iframe>
            </b-col>
         </div>


       </b-modal> 
              <b-col sm="12" class="text-right" >
              <button id="skytracking" style="display:none;float:right;"  @click="skyexpressmodel()" v-b-tooltip.hover title="SkyExpress Tracking" class="btn btn-sm btn-primary mr-4 btn-pill"><i class="fa fa-television" aria-hidden="true"></i> &nbsp;SkyExpress</button> 
              </b-col> 
           <br>
          <b-col md="12">
            <b-table show-empty stacked="md" style="table-layout: fixed"  :busy="isBusy" :items="ConsignmentMasterGetdata" :bordered="bordered" :fields="fields"   :outlined="outlined"  >
               <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
            </b-table>
          </b-col>
          <!--   <span style="color:red; float: right;" 
            v-if="is_mark_ofd==2"> 
              <b>Client Pick Cancel Request Received for this Shipment</b>
            </span> -->

   
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      isBusy: false,
      is_history_Busy:false,
      customer: {},
      outlined:true,
      bordered: true,
      data: [],
      items: [],
      dlvstatus:[],
      rpickdoneimg:[],
      img1:[],
      is_mark_ofd:0,
      imgpath:[],
      rpickdoneimgpath:[],
      urlrpickdoneImg:[],
      urlImg: [],
      rpickdonepath:[],
       customlogdata: [],
        smslogdata: [],
        searchvaluesarr:[],
        shippingid:'',
    
      logisticlogdata: [],
      fields: [
      {key: 'shippingid', label: 'Shipping Id',tdClass: 'nameOfTheClass'}, 
      {key: 'status',label:'Status',tdClass: 'nameOfTheClass'}, 
      {key: 'createdby',label:'Created By',tdClass: 'nameOfTheClass'},
      {key: 'createddate',label:'Created Date',tdClass: 'nameOfTheClass'},
      
      ],
     
     
     
      ConsignmentMasterGetdata: [],
      isConsignmentActivityTrackingGetWeb: 0,
      isConsignmentMasterGetStatus: 0,
      isGetlogisticlogdetails: 0,
      showskyexpress:false,
      finaltrackinglink:'',

    }
  },
  created: function () {},
  methods: {
    skyexpressmodel:function(){
      // alert("innnn");
      this.finaltrackinglink="https://skyexpressinternational.com/Home/Tracking";
      this.showskyexpress =! this.showskyexpress;
    },
    validateForm(scope) {
     
      // var searchvaluesarr = []
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
         
          var shipmentid = this.customer.shipmentid
          var searchvalues = shipmentid.split(',')
          for (var i = 0; i < searchvalues.length; i++) {
            this.searchvaluesarr.push(`${searchvalues[i]}`)
          }
          // const customerGetAllobj = {
          //   shippingid: searchvaluesarr
          // }
          // this.shippingid=this.customer.shipmentid;
          // this.shippingid=this.searchvaluesarr;

          this.tracking_main(this.searchvaluesarr);
         
    
        }
      })
    },

    tracking_main:function(value){
      // alert(value)
     this.isBusy = true;
          const Getobj = {
            shippingid: value,
          }

         
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/skyexpressshipmentactivitytracking`, Getobj)
            .then((result) => {

               // console.log("result",result);
              if (result.body.length > 0) {
                // alert("inn");
                this.searchvaluesarr=[];
                this.ConsignmentMasterGetdata = result.body
                 document.getElementById("skytracking").style.display ="block";
                // this.shippingid=result.body[0].shippingid;
                // console.log("ggggggg",this.shippingid);
     

                this.isBusy =!this.isBusy;
              
              } else {
                alert(result.body.returnvalue)
                this.ConsignmentMasterGetdata = []
                // this.isConsignmentMasterGetStatus = 1
                this.isBusy =!this.isBusy;

          document.getElementById("skytracking").style.display ="none";
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
    },


    

    clear: function() {
      this.customer = {}
      this.searchvaluesarr=[]
      this.ConsignmentMasterGetdata = []
      this.customlogdata = []
      this.smslogdata = []
      this.logisticlogdata = []
       this.data = []
      this.errors.clear('form-1')
      document.getElementById("skytracking").style.display ="none";
      // var searchlisting = document.getElementById('searchlisting')
      // searchlisting.style.display = 'none'
      // var searchlisting2 = document.getElementById('searchlisting2')
      // searchlisting2.style.display = 'none'
    }
  },

  filters: {
    datechange: function (value) {
      if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    }
  }
};
</script>
<style type="text/css">
  .b-table-caption-top{
    color: black;
  }

</style>
